import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-leave',
  templateUrl: './org-leave.component.html',
  styleUrls: ['./org-leave.component.css']
})
export class OrgLeaveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
